var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookingPot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610.32 468.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#e57b07;}.g,.h,.i,.j,.k,.l,.m,.n{stroke-linecap:round;stroke-linejoin:round;}.g,.h,.j,.k,.l,.m,.n{stroke:#070707;}.g,.i,.j,.k,.l,.m,.n{stroke-width:4px;}.h{stroke-width:4px;}.h,.n{fill:#f7f3ef;}.i{fill:#f9c576;stroke:#000;}.j{fill:#98a2b3;}.k{fill:#51679b;}.l{fill:#f9b686;}.m{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M295.2,150.87s20.28-33.67,52.45-23.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M307.13,136.37s13-.83,10.16,5.58c-1.78,4.05-18,1.41-18,1.41,0,0,.55-17.8,7.68-17.65,5.69,.11,.16,10.66,.16,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M316.91,129.5s11.87,1.31,7.57,5.11c-2.18,1.93-15.59,.35-15.59,.35,0,0,6-15.84,11.81-16.33s-3.79,10.87-3.79,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M332.31,125.33s9.26,3.16,6.05,6.22c-1.56,1.48-14.11-4.44-14.11-4.44,0,0,5.67-10.22,11.18-8.57,3.64,1.12-3.12,6.79-3.12,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M336.42,125.22s20.38-5.53,19.3,3c-.77,6.37-19.3-3-19.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.42,167.39s3.5-38.61-29.1-47.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M286.35,138.13s-10.55-5.29-9.3,.14c.64,2.77,12.62,8.67,12.62,8.67,0,0,4.53-16.29,.08-19.79s-3.4,10.98-3.4,10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M276.17,126.42s-9.51-2.37-8.7,1.87c.39,2.06,14.27,3.93,14.27,3.93,0,0,1.47-11.46-4.06-13.06-3.65-1.06-1.51,7.26-1.51,7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M272.82,124.11s-13.45-15.51-17.66-7.94c-3.18,5.71,17.66,7.94,17.66,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M289.53,148.91s19.76-36.65-5.77-57.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M296.42,116.43s-6.22-8.17-7.53-2.76c-.66,2.76,7.52,12.91,7.52,12.91,0,0,11.18-11,7.32-18.34-2.62-4.9-7.31,8.19-7.31,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M293.42,102.66s-7.54-6-8.73-1.81c-.57,2,11.16,9.28,11.16,9.28,0,0,6.5-9.76,2.21-13.43-2.86-2.48-4.64,5.96-4.64,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.42,99.17s-5.19-19.43-12.41-14.28c-5.48,3.88,12.41,14.28,12.41,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M223.69,357.96h0c-3.96-1.03-6.41-5-5.54-9l43.86-186.2c2.71-11.05,14.77-17.61,26.27-14.28l5.81,1.69c11.5,3.33,17.62,15.16,13.32,25.76l-73.83,177.53c-1.69,3.78-5.93,5.7-9.89,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M363.6,180.93s20.28-33.66,52.44-23.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M375.52,166.43s13-.83,10.16,5.59c-1.78,4-18,1.41-18,1.41,0,0,.54-17.8,7.67-17.66,5.7,.12,.17,10.66,.17,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M385.31,159.56s11.86,1.32,7.56,5.11c-2.18,1.93-15.58,.35-15.58,.35,0,0,6-15.84,11.8-16.33s-3.78,10.87-3.78,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M400.71,155.39s9.25,3.16,6,6.22c-1.55,1.49-14.1-4.44-14.1-4.44,0,0,5.66-10.22,11.17-8.57,3.69,1.06-3.07,6.79-3.07,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M404.86,155.29s20.37-5.54,19.3,3c-.81,6.37-19.3-3-19.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M359.79,197.46s3.51-38.62-29.1-47.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M354.74,168.2s-10.55-5.3-9.29,.14c.64,2.76,12.62,8.66,12.62,8.66,0,0,4.52-16.29,.08-19.78s-3.41,10.98-3.41,10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M344.57,156.49s-9.51-2.37-8.71,1.87c.39,2.06,14.27,3.92,14.27,3.92,0,0,1.47-11.45-4.06-13.06-3.65-1.06-1.5,7.27-1.5,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M341.22,154.17s-13.46-15.51-17.67-7.94c-3.13,5.71,17.67,7.94,17.67,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M357.92,178.97s19.76-36.64-5.76-57.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M364.77,146.49s-6.22-8.17-7.53-2.75c-.67,2.75,7.52,12.91,7.52,12.91,0,0,11.17-11,7.31-18.35-2.56-4.9-7.3,8.19-7.3,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M361.78,132.66s-7.54-6-8.72-1.81c-.58,2,11.15,9.29,11.15,9.29,0,0,6.5-9.77,2.21-13.44-2.83-2.42-4.64,5.96-4.64,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M359.79,129.23s-5.19-19.43-12.41-14.28c-5.45,3.89,12.41,14.28,12.41,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M292.08,388.02h0c-3.96-1.02-6.41-5-5.53-9l43.87-186.17c2.71-11.05,14.77-17.61,26.27-14.27l5.82,1.69c11.5,3.33,17.61,15.16,13.31,25.75l-73.83,177.5c-1.69,3.79-5.94,5.72-9.91,4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 186.05,
    y: 133.93,
    width: 5.32,
    height: 299.95,
    transform: "translate(-111.59 122.56) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 194.14,
    y: 129.61,
    width: 5.32,
    height: 299.95,
    transform: "translate(-108.6 125.87) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 210.33,
    y: 120.95,
    width: 5.32,
    height: 299.95,
    transform: "translate(-102.6 132.47) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 226.51,
    y: 112.29,
    width: 5.32,
    height: 299.95,
    transform: "translate(-96.6 139.08) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 202.23,
    y: 125.27,
    width: 5.32,
    height: 299.95,
    transform: "translate(-105.6 129.17) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 218.42,
    y: 116.61,
    width: 5.32,
    height: 299.95,
    transform: "translate(-99.6 135.78) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 234.61,
    y: 107.97,
    width: 5.32,
    height: 299.95,
    transform: "translate(-93.61 142.39) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 246.75,
    y: 127.43,
    width: 5.32,
    height: 299.95,
    transform: "translate(-101.35 150.42) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 254.83,
    y: 123.11,
    width: 5.32,
    height: 299.95,
    transform: "translate(-98.36 153.72) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 262.93,
    y: 118.78,
    width: 5.32,
    height: 299.95,
    transform: "translate(-95.36 157.03) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 271.03,
    y: 114.46,
    width: 5.32,
    height: 299.95,
    transform: "translate(-92.36 160.34) rotate(-28.14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M121.52,195.02H430.72v228.64c0,23.91-19.39,43.3-43.3,43.3H164.82c-23.91,0-43.3-19.39-43.3-43.3V195.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M430.72,217.66h36.07l38.8-24.12c2.1-1.62,2.88-4.43,1.93-6.9h0c-1.65-4.17-7.33-5.51-11-2.6l-34.8,20.91h-31v12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M121.5,217.66h-36.08l-38.8-24.15c-2.1-1.62-2.88-4.43-1.93-6.9h0c1.65-4.17,7.34-5.51,11-2.6l34.73,20.91h31l.08,12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M430.72,127.46L143.05,14.1C164.76-.11,229.69,8.38,300.49,36.27s124.05,65.99,130.23,91.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M334.24,19.87L290.14,2.49c-4.27-1.68-8.76,1.12-8.63,5.4l.65,21.26,39.73,15.66,15-15.11c2.99-3.04,1.62-8.15-2.65-9.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M575.28,215.12h-5.59c.46,.93,.7,1.96,.71,3v5.11c0,2.57-2.08,4.65-4.65,4.66h-28.27c-2.57,0-4.66-2.09-4.66-4.66v-5.07c0-1.04,.25-2.07,.71-3h-5.83v-9.77c0-3.78,3.06-6.85,6.84-6.86h33.88c3.78,0,6.85,3.06,6.86,6.84v9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M597.6,346.77l-5.85,86.07c-.41,7.5-6.56,13.41-14.07,13.51h-52.38c-7.51-.1-13.67-6.01-14.07-13.51l-5.81-86.07h92.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M608.25,322.06l-8.32,118.86c-.66,8.86-8.03,15.72-16.92,15.74h-63c-8.9-.02-16.28-6.9-16.92-15.78l-8.36-118.82c-.68-9.62,3.69-18.9,11.54-24.5,8.54-5.93,13.64-15.66,13.66-26.06l-.36-44.67c-.28-6.18,4.51-11.42,10.7-11.7,.17,0,.33-.01,.5-.01h41.43c6.19-.01,11.22,5,11.23,11.19,0,.17,0,.35-.01,.52l-.37,44.67c.03,10.4,5.13,20.13,13.67,26.06,7.85,5.6,12.21,14.88,11.53,24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M580.6,394.19c-.89,5-13.63,11.19-29.2,11.19s-28.31-6.24-29.21-11.19l.12-62.57c1.6-4.74,14-10.71,29.09-10.71s27.49,6,29.09,10.71l.11,62.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M32.51,298.38v2.14c0,2.45,1.98,4.43,4.43,4.44h0v6.7c0,2.54,2.07,4.6,4.61,4.6h8.87c2.54,0,4.6-2.05,4.61-4.59h0v-6.71h0c2.45,0,4.43-1.98,4.43-4.43h0v-2.15c0-2.45-1.98-4.43-4.43-4.43h-18.09c-2.44,0-4.42,1.99-4.43,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2,412.74c0,11.37,6.88,28.68,13.17,38.86,1.44,2.35,4,3.78,6.76,3.78h44.66c2.79-.01,5.38-1.48,6.82-3.87,6.27-10.48,13.15-29,13.15-40.37,0-22.8-10.36-39.74-28.07-46.6v-44.88l9.62-14.72H30.11v59.58c-17.75,6.88-28.11,25.43-28.11,48.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M30.08,316.3h-12.66c-6.89,0-12.46,5.6-12.46,12.48,0,1.44,.25,2.88,.75,4.24l13.65,37.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M8.69,413.08c0,9.57,5.8,24.14,11.09,32.71,1.22,1.98,3.37,3.18,5.69,3.18H63.06c2.35,0,4.53-1.24,5.74-3.26,5.28-8.82,11.07-24.42,11.07-34,.06-5.78-.84-11.52-2.68-17H11.72c-2.06,5.9-3.09,12.12-3.03,18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M505.88,342.73v108.23c0,2.88-2.34,5.22-5.22,5.22h-41.24c-2.88,0-5.21-2.32-5.22-5.2v-108.25c-.01-7.5,5.31-13.95,12.67-15.37v-25.82h26.34v25.82c7.36,1.42,12.68,7.87,12.67,15.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M498.29,358.29v85.65c0,3.14-2.23,5.68-5,5.68h-26.53c-2.75,0-5-2.54-5-5.68v-85.65h36.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 460.98,
    y: 297.5,
    width: 38.12,
    height: 8.38,
    rx: 2.4,
    ry: 2.4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingPot);
export default __webpack_public_path__ + "static/media/cookingPot.7ad095505a0fec9c242721c207bfdab0.svg";
export { ForwardRef as ReactComponent };